import React from 'react';
import type { ReactElement } from 'react';
import styled from 'styled-components';
import { Stack, Ul, Li, paletteHelper, typographyHelper } from '@construct-kit/core';
import {
  channelForSelectElement,
  getChannelObjectFromChannelId,
} from '../../../../shared/model/constants/channels';
import type { AllChannelObjects, ChannelObject } from '../../../../shared/model/tsTypes';
import type { FilterOptionType } from '../../../../shared/model/constants/filterTypes';
import { FilterPillButton } from './FilterPillButton';

export interface FilterPillChannelProps {
  selectedChannel: AllChannelObjects;
  onChange: (newValue: ChannelObject) => void;
  trackPillClick: () => void;
}

const StyledUnorderedList = styled(Ul)`
  & .selected {
    background-color: ${paletteHelper('backgroundSecondaryBase')};
  }
  list-style-type: none;
  padding: 0;
`;

const StyledListItem = styled(Li)`
  ${typographyHelper('body01')};
  &:hover {
    cursor: pointer;
  }
  font-size: 16px;
  padding: 0.625rem 14.1875rem 0.625rem 1.5rem;
`;
const StyledStack = styled(Stack)`
  padding: 0.875rem 0 0.875rem 0;
`;

export const FilterPillChannel = ({
  selectedChannel,
  onChange,
  trackPillClick,
}: FilterPillChannelProps): ReactElement => {
  const handleChannelChange = (value: string): void => {
    onChange(getChannelObjectFromChannelId(value));
  };

  return (
    <FilterPillButton
      label={selectedChannel.shortHumanReadable}
      selected
      hideOverlayFooter
      popOverPlacement="bottom-start"
      onFilterPillOpen={() => {
        trackPillClick();
      }}
    >
      <StyledStack inset="medium" gap="small">
        <StyledUnorderedList>
          {channelForSelectElement.map(({ label, value }: FilterOptionType) => (
            <StyledListItem
              aria-label={label}
              key={value}
              className={selectedChannel.id === value ? 'selected' : ''}
              onClick={() => handleChannelChange(value)}
              tabIndex={0}
            >
              {label}
            </StyledListItem>
          ))}
        </StyledUnorderedList>
      </StyledStack>
    </FilterPillButton>
  );
};
